export function getBanlistpgs ({ state, commit }, { search, page = 1 }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/banlistpgs', { params: { search, page } })
      .then((response) => {
        if (response.data.banlistpgs) {
          commit('setBanlistpgs', response.data.banlistpgs)
        }

        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getBanlistpg ({ state, commit }, banlistpgId) {
  return new Promise((resolve, reject) => {
    if (banlistpgId) {
      axiosInstance.get('/v1/banlistpgs/' + banlistpgId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No banlistpg id'))
    }
  })
}

export function getCreateBanlistpg ({ state, commit }) {
  return new Promise((resolve, reject) => {
    axiosInstance.get('/v1/banlistpgs/create')
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function createBanlistpg ({ state, commit }, { id, description, procent }) {
  return new Promise((resolve, reject) => {
    axiosInstance.post('/v1/banlistpgs', { id, description, procent })
      .then((response) => {
        resolve(response)
      })
      .catch((error) => {
        reject(error)
      })
  })
}

export function getEditBanlistpg ({ state, commit }, banlistpgId) {
  return new Promise((resolve, reject) => {
    if (banlistpgId) {
      axiosInstance.get('/v1/banlistpgs/' + banlistpgId + '/edit')
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No banlistpg id'))
    }
  })
}

/* eslint-disable-next-line */
export function editBanlistpg ({ state, commit }, { id, description, procent }) {
  return new Promise((resolve, reject) => {
    if (id) {
      axiosInstance.patch('/v1/banlistpgs/' + id, { description, procent })
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No banlistpg id'))
    }
  })
}

export function deleteBanlistpg ({ state, commit }, banlistpgId) {
  return new Promise((resolve, reject) => {
    if (banlistpgId) {
      axiosInstance.delete('/v1/banlistpgs/' + banlistpgId)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    } else {
      reject(new Error('No banlistpg id'))
    }
  })
}
